import { createPortal } from "react-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Calendar } from "lucide-react";
import { cn } from "../../lib/utils";

type CustomDatePickerProps = {
  value: Date | undefined;
  onChange: (date: Date | undefined) => void;
  /** Render popper in document.body with higher z-index (use inside dialogs) */
  inModal?: boolean;
  popperClassName?: string;
};

export default function CustomDatePicker({
  value,
  onChange,
  inModal = false,
  popperClassName,
}: CustomDatePickerProps) {
  return (
    <div
      className="relative w-full"
      onPointerDown={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
    >
      <DatePicker
        selected={value}
        onChange={(date) => onChange(date ?? undefined)}
        dateFormat="MMMM d, yyyy"
        className="
          w-full h-10 px-3 pr-9 rounded-md border 
          border-gray-300 focus:ring-2 focus:ring-primary 
          focus:border-primary outline-none text-sm
        "
        calendarClassName="rounded-lg border shadow-lg p-3 bg-white"
        dayClassName={() =>
          "w-9 h-9 flex items-center justify-center rounded-md hover:bg-accent hover:text-accent-foreground"
        }
        wrapperClassName="w-full"
        popperClassName={cn(inModal && "!z-[9999]", popperClassName)}
        popperPlacement="bottom-start"
        popperContainer={
          inModal
            ? ({ children }) => createPortal(children, document.body)
            : undefined
        }
        onCalendarOpen={() => {
          requestAnimationFrame(() => {
            document
              .querySelectorAll(".react-datepicker-popper")
              .forEach((el) => {
                (el as HTMLElement).style.zIndex = "9999";
              });
          });
        }}
      />

      {/* Calendar icon inside input */}
      <Calendar className="absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-500 pointer-events-none" />
    </div>
  );
}
